export const reZoneConstants = {
	GetZones: {
		REQUEST : 'GET_NRI_ZONES_REQUEST',
		SUCCESS : 'GET_NRI_ZONES_SUCCESS',
		FAILURE : 'GET_NRI_ZONES_FAILURE'
	},
	ClearZones: 'CLEAR_NRI_ZONES'
}